<template>
  <v-list-item dense style="height: 28px">
      <v-list-item-avatar size="30" class="icon-wrapper">
        <v-icon size="16" :color="color">{{icon}}</v-icon>
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title>
          <div class="caption text-left" v-html="text"></div>
        </v-list-item-title>
      </v-list-item-content>
  </v-list-item>
</template>

<script>
export default {
  name: "FeatureItem",
  props:{
    color: {
      type: String,
      default: 'primary'
    },
    text: {
      type: String,
      required: true
    },
    icon:{
      type: String,
      default: 'far fa-check-circle'
    }
  }
}
</script>

<style scoped>
  .icon-wrapper{
    min-width: 35px !important;
    width: 30px !important;
  }
</style>
